import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Zone from "@frog/source/models/Zone.js"

let UnitSprite = function() {}
import("@frog/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import Dice from "@frog/source/data/games/dice/views/Dice.jsx"
import DiceCube from "@frog/source/data/games/dice/views/DiceCube.jsx"
import DiceLayout from "@frog/source/data/games/dice/views/DiceLayout.jsx"

import {Roll} from "@frog/source/data/games/dice/scripts/Rolling.js"
import CarryOn from "@frog/source/data/games/dice/scripts/CarryOn.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

import "./Modals.less"

function onClickUnit(unit) {
    return function(event) {
        unit.isLockedIn = !unit.isLockedIn
    }
}

function onClickReroll(stage) {
    return function(event) {
        if(stage.player.rollcount <= 0) return
        stage.player.rollcount -= 1
        Object.values(stage.units).forEach((unit) => {
            if(unit.isLockedIn) return
            if(unit.affiliation != stage.player.affiliation) return
            unit.rollcount = stage.player.rollcount
            unit.primaryItem = stage.random.element(Object.values(unit.diceFaces))
            unit.equippedItem = unit.primaryItem
        })
    }
}

function onClickDone(stage) {
    return function(event) {
        Object.values(stage.units).forEach((unit) => {
            delete unit.isLockedIn
        })

        CarryOn(stage)
    }
}

function getUnits(stage) {
    return Object.values(stage.units).filter((unit) => {
        return unit.isDead != true
            && unit.affiliation == stage.player.affiliation
            && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
    })
}

export default function RollingModal() {
    return [
        Roll(),
        PlotSteps.CustomViewModal({
            "view": (stage) => {
                if(App?.game == undefined) return
                return (
                    <div class="RollingModal">
                        <section class="UnitsSection">
                            {getUnits(stage).map((unit, index) => {
                                return (
                                    <div class="Unit" onClick={onClickUnit(unit)} isLockedIn={unit.isLockedIn}>
                                        <div class="EquippedDice">
                                            <DiceCube unit={unit} stage={stage} key={unit.rollcount} item={unit.equippedItem}
                                                animation="roll" anchored={"bottom"} playerIndex={index}/>
                                        </div>
                                        <div class="Thumbnail">
                                            <UnitSprite unit={unit}/>
                                            <UnitHealthBar unit={unit} maxsegments={20}/>
                                        </div>
                                        <div class="EquippableDice">
                                            <div class="Description">{unit.subtitle} Dice:</div>
                                            <DiceLayout items={unit.diceFaces} unit={unit} stage={stage}
                                                equippedItem={unit.equippedItem} key={unit.rollcount}/>
                                        </div>
                                        <div class="Status">
                                            Ready!!
                                        </div>
                                    </div>
                                )
                            })}
                        </section>
                        <section class="DoneSection">
                            <button onClick={onClickReroll(stage)} isEnabled={stage.player.rollcount >= 1}>
                                Reroll ({stage.player.rollcount} of 3)
                            </button>
                            <button onClick={onClickDone(stage)} isEnabled={true}>Done</button>
                        </section>
                    </div>
                )
            }
        })
    ]
}
